export const ALLOWED_GAME_CHALLENGE_TYPES = {
  all: [
    'completeprofile',
    'makeconnection',
    'attendsession',
    'openapp',
    'speakers',
    'exhibitors',
    'exhibitor',
    'sponsor',
    'news',
    'social',
    'community',
    'globalsearch',
    'conversationer',
    'sendmessage',
    'scansessionqr',
    'scanexhibitorqr',
    'scansponsorqr',
    'gallerycontest',
    'scanspeakerqr',
    'scanuserqr',
    'trivia',
    'sendmessage',
    'bookmarkitem',
    'ratesession',
    'liveqaask',
    'liveqalike',
    'exhibitorconnect',
    'qr',
    'sociallike',
    'socialcomment',
    'socialvote',
    'survey',
    'communitylike',
    'communitycomment',
    'socialaddpoll',
    'gallerypost',
    'communitygetlike',
    'communitygetcomment',
    'socialphotopost',
    'scansessionqr',
    'scansponsorqr',
    'scanexhibitorqr'
  ],
  types: {
    completeprofile: 'completeprofile',
    makeconnection: 'makeconnection',
    attendsession: 'attendsession',
    openapp: 'openapp',
    speakers: 'speakers',
    exhibitors: 'exhibitors',
    exhibitor: 'exhibitor',
    sponsor: 'sponsor',
    news: 'news',
    social: 'social',
    community: 'community',
    conversationer: 'conversationer',
    globalsearch: 'globalsearch',
    sendmessage: 'sendmessage',
    scansessionqr: 'scansessionqr',
    scanexhibitorqr: 'scanexhibitorqr',
    scansponsorqr: 'scansponsorqr',
    gallerycontest: 'gallerycontest',
    scanspeakerqr: 'scanspeakerqr',
    scanuserqr: 'scanuserqr',
    trivia: 'trivia',
    sendmessage: 'sendmessage',
    bookmarkitem: 'bookmarkitem',
    ratesession: 'ratesession',
    liveqaask: 'liveqaask',
    liveqalike: 'liveqalike',
    exhibitorconnect: 'exhibitorconnect',
    qr: 'qr',
    sociallike: 'sociallike',
    socialcomment: 'socialcomment',
    socialvote: 'socialvote',
    survey: 'survey',
    communitylike: 'communitylike',
    communitycomment: 'communitycomment',
    socialaddpoll: 'socialaddpoll',
    gallerypost: 'gallerypost',
    communitygetlike: 'communitygetlike',
    communitygetcomment: 'communitygetcomment',
    socialphotopost: 'socialphotopost',
    scansessionqr: 'scansessionqr',
    scansponsorqr: 'scansponsorqr',
    scanexhibitorqr: 'scanexhibitorqr'
  }
};

export const ALLOWED_SCAN_TYPE_CHALLENGES = {
  all: [
    'scansessionqr',
    'scanexhibitorqr',
    'scansponsorqr',
    'scanspeakerqr',
    'scanuserqr'
  ],
  types: {
    scansessionqr: 'scansessionqr',
    scanexhibitorqr: 'scanexhibitorqr',
    scansponsorqr: 'scansponsorqr',
    scanspeakerqr: 'scanspeakerqr',
    scanuserqr: 'scanuserqr'
  }
};
